/** @format */

import { FC } from "react";
import { ROUTES } from "utils";
import { AuthLayout } from "components/Layouts";
import { Home } from "pages/admin/home";
import HomeLayout from "components/Layouts/HomeLayout";
import { Login } from "pages/auth/login";

type TComponent = FC<{
  children: string | JSX.Element | JSX.Element[] | JSX.Element;
}>;

export interface RouterType {
  path: string;
  component: FC;
  layout: TComponent;
}

const publicRoutes: RouterType[] = [
  {
    path: ROUTES.PUBLIC_URL.LOGIN,
    component: Login,
    layout: AuthLayout as TComponent,
  },
];

const privateRoutes: RouterType[] = [
  {
    path: "/",
    component: Home,
    layout: HomeLayout as TComponent,
  },
  {
    path: ROUTES.PRIVATE_ROOT.DASHBOARD,
    component: Home,
    layout: HomeLayout as TComponent,
  },
];

export { privateRoutes, publicRoutes };
